export * from './env';
export * from './types';
export * from './value';
export * from './webp';

/**
 * 检查是否需要更新
 * @param currentVersion 当前版本
 * @param remoteVersion  最新版本
 */
export function checkIfNeedUpdate(
  currentVersion: string,
  remoteVersion: string,
): boolean {
  const [a1, a2, a3] = currentVersion.split('.');
  const [b1, b2, b3] = remoteVersion.split('.');
  if (b1 !== a1) {
    return b1 > a1;
  }
  if (b2 !== a2) {
    return b2 > a2;
  }
  return b3 > a3;
}
